export default __webpack_public_path__ + "static/featureSectionImg-1bd8a6d2d931faffdbd3851fe4091bf9.png";